import * as yup from 'yup'

export const EmailAuthSchemaValidations = yup.object().shape({
  emailProvider: yup
    .mixed()
    .required('El proveedor de correo es obligatorio'),
  accountType: yup.string().required('El tipo es obligatorio'),
})

const SchemaValidations = yup.object().shape({
  clientName: yup
    .string()
    .required('El nombre de cliente o empresa es obligatorio'),

  nit: yup.string().when('dteType', {
    is: (value) => value !== '01',
    then: yup.string().required('El NIT es obligatorio'),
    otherwise: yup.string().nullable(),
  }),
  nrc: yup.string().when('dteType', {
    is: (value) => value !== '01',
    then: yup.string().required('El NRC es obligatorio'),
    otherwise: yup.string().nullable(),
  }),
  department: yup.mixed().when('dteType', {
    is: (value) => value !== '01',
    then: yup.mixed().required('El departamento es obligatorio'),
    otherwise: yup.mixed().nullable(),
  }),
  municipality: yup.mixed().when('dteType', {
    is: (value) => value !== '01',
    then: yup.mixed().required('El municipio es obligatorio'),
    otherwise: yup.mixed().nullable(),
  }),
  district: yup.mixed().when('dteType', {
    is: (value) => value !== '01',
    then: yup.mixed().required('El distrito es obligatorio'),
    otherwise: yup.mixed().nullable(),
  }),
  largeConsumer: yup.mixed().when('dteType', {
    is: (value) => value !== '01',
    then: yup.mixed().required('El tipo de contribuyente es obligatorio'),
    otherwise: yup.mixed().nullable(),
  }),
  economicActivity: yup.mixed().when('dteType', {
    is: (value) => value !== '01',
    then: yup.mixed().required('La actividad económica es obligatoria'),
    otherwise: yup.mixed().nullable(),
  }),
  address: yup.string().required('La dirección es obligatoria'),
  company: yup.string().required('La sociedad es obligatoria'),

  phoneNumber: yup
    .string()
    .matches(
      /^\+[0-9]{8,15}$/,
      'El número de teléfono debe ser válido y debe incluir el prefijo internacional con "+"'
    )
    .required('El número de teléfono es obligatorio'),
  email: yup
    .string()
    .email('No es un correo válido')
    .required('El correo emisión es obligatorio'),
  incomingEmail: yup
    .string()
    .email('No es un correo válido')
    .required('El correo de recepción es obligatorio'),
  typeOffer: yup.mixed().required('El tipo de producto es obligatorio'),
})

// Esquema de validación para productos
const ProductSchema = yup.object().shape({
  productCode: yup
    .string()
    .required('El código del producto es obligatorio'),
  prodType: yup.mixed().required('El tipo de producto es obligatorio'),
  productName: yup
    .string()
    .required('El nombre de producto es obligatorio'),
  quantity: yup
    .number()
    .required('La cantidad del producto es obligatoria')
    .positive('La cantidad debe ser un número positivo'),
  unitOfMeasure: yup
    .mixed()
    .required('La unidad de medida es obligatoria'),
  TypeOfSale: yup.string().required('El Tipo de venta es obligatorio'),
  price: yup
    .number()
    .required('El precio del producto es obligatorio')
    .positive('El precio debe ser un número positivo'),
})

// Esquema de validación para observaciones
const ObservationSchema = yup.object().shape({
  conditionOperations: yup
    .string()
    .required('La condición de operaciones es obligatoria')
    .max(500, 'La observación no puede exceder los 500 caracteres'),
  typePayment: yup.string().required('La forma de pago es obligatoria'),
  amount: yup.string().required('El monto es obligatorio'),
})

export { SchemaValidations, ProductSchema, ObservationSchema }
